import React, { useState } from 'react';
import { Tooltip, Typography } from '@mui/material';
import { NameEmailAvatar } from '../../../../../../ui';
import { ContextMenu, MenuItemType } from '../../../../../../ui/components/Common/ContextMenu/ContextMenu';
import { RefreshListIcons } from '../../../../../../icons/icons';
import { ContextMenuButton } from '../../../../../../ui/components/Common/ContextMenu/ContextMenuButton';
import { CandidateListType } from '../index';

const TooltipWrapper: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Tooltip title={text || ''} arrow placement='top'>
      <Typography
        variant='body2'
        sx={{
          maxWidth: 180,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
        }}
      >
        {text || '-'}
      </Typography>
    </Tooltip>
  );
};

const ActionMenu: React.FC<{ row: CandidateListType; onRetake: (row: CandidateListType) => void }> = ({ row, onRetake }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const menuItems: MenuItemType<CandidateListType>[] = [
    {
      label: 'Remove Invite',
      icon: <RefreshListIcons />,
      permission: [],
      onClick: () => onRetake(row),
    },
  ];

  if (!row.invited) {
    return null;
  }

  return (
    <>
      <ContextMenuButton
        row={row}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        anchorEl={anchorEl}
      />
      <ContextMenu
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        row={row}
        menuItems={menuItems}
      />
    </>
  );
};

// Add near the top of getColumns.tsx, above the components
const formatStatusLabel = (value: string): string => {
  if (!value) return '';

  return value
    .split(/[-_]/)
    .map((part) =>
      part
        .replace(/Inprogress/gi, 'In Progress')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
    )
    .join(' ')
    .trim();
};

export const getColumns = (onRetake: (row: CandidateListType) => void) => [
  {
    key: 'candidate',
    label: 'Candidate',
    width: '200px',
    align: 'left' as const,
    disableSort: true,
    render: (row: CandidateListType) => (
      <NameEmailAvatar
        email={row.email}
        name={row.name}
        avatar={''}
      />
    ),
  },
  {
    key: 'applicantStatus',
    label: 'Applicant Status',
    width: '200px',
    align: 'left' as const,
    disableSort: false,
    render: (row: CandidateListType) => <TooltipWrapper text={formatStatusLabel(row.applicantStatus)} />,
  },
  {
    key: 'psychometricStatus',
    label: 'Status',
    width: '200px',
    align: 'left' as const,
    disableSort: false,
    render: (row: CandidateListType) => <TooltipWrapper text={formatStatusLabel(row.psychometricStatus)} />,
  },
  {
    key: 'invited',
    label: 'Invited',
    width: '100px',
    align: 'left' as const,
    disableSort: false,
    render: (row: CandidateListType) => (
      <TooltipWrapper text={row.invited ? 'YES' : 'NO'} />
    ),
  },
  {
    key: 'actions',
    label: '',
    width: '50px',
    align: 'right' as const,
    disableSort: true,
    render: (row: CandidateListType) => <ActionMenu row={row} onRetake={onRetake} />,
  },
];